import React from 'react';
import PageSection from "../components/PageSection";

const JobPostingPage = () => {
    return (
        <div className="Page job-posting-page">
            <PageSection>
                <h1 className="job-posting-title">Notice of Filing</h1>

                <section className="job-details">
                    <h2 className="job-position">Blockchain Explorer Engineer</h2>
                    <p className="job-company-location">(SLIVER VR Technologies, Inc.; San Jose, CA)</p>

                    <p className="job-description">
                        Build a web application to explore and search the Theta blockchain for blocks, transactions,
                        addresses, and other activities taking place on Theta. Implement React framework to build the
                        frontend application, use Express.js as the backend server framework and MongoDB, and Aerospike
                        as the database. Apply Axios (AJAX) to communicate with the backend API. Utilize AWS EC2 to host
                        the website. Use Sass and BEM (class naming convention) to make front-end coding more
                        maintainable. Participate in building a library to support live streaming and video-on-demand
                        platforms integrated with Theta network and P2P content sharing feature. Responsible for the
                        client-side P2P network optimization, providing a high-quality stable stream with a better
                        offload percentage.
                    </p>

                    <p className="job-salary">
                        <strong>Salary:</strong> $184,662 per year
                    </p>

                    <p className="job-application">
                        Applicants should email their resume to: <a href="mailto:susanna@sliver.tv">susanna[at]sliver[dot]tv</a>
                    </p>
                </section>

                <section className="job-notice">
                    <p>
                        This notice is provided in anticipation of the filing of an application for permanent alien
                        labor certification. Any person may provide documentary evidence bearing on the application to
                        the U.S. Department of Labor, Employment and Training Administration, Office of Foreign Labor
                        Certification, 200 Constitution Avenue NW, Room N-5311, Washington, DC 20210.
                    </p>
                </section>
            </PageSection>

        </div>
    );
};

export default JobPostingPage;
